import { JtechAxios } from 'src/plugins/axios'

const contractRepository = {
  saveClient: async (data) => {
    return JtechAxios.request().put('/integration/sales-force/client', data, {
      headers: {
        'Content-Type': 'application/json;'
      }
    })
  },

  saveContract: async (data) => {
    return JtechAxios.request().put('/integration/sales-force/contract', data, {
      headers: {
        'Content-Type': 'application/json;'
      }
    })
  },

  saveContractAndClient: async (data) => {
    return JtechAxios.request().put('/integration/sales-force/contractAndClient', data, {
      headers: {
        'Content-Type': 'application/json;'
      }
    })
  },

  saveContractAdditive: async (data) => {
    return JtechAxios.request().put('/integration/sales-force/contract/aditive', data, {
      headers: {
        'Content-Type': 'application/json;'
      }
    })
  },

  saveContractRenovation: async (data) => {
    return JtechAxios.request().put('/integration/sales-force/contract/renovation', data, {
      headers: {
        'Content-Type': 'application/json;'
      }
    })
  }
}

export default contractRepository
